import config from './global.js';
const Api = {
  login: (body) => {
    return config.axiosHandle().post('v0/admin/login', body);
  },
  coutryList: () => {
    return config.axiosHandle().get('v0/country/list');
  },
  KidzySendCode: (body) => {
    return config.axiosHandle().post('v0/kidzy/send-code', body);
  },
  KidzySignup: (body) => {
    return config.axiosHandle().post('v0/kidzy/signup', body);
  },
  logOutFunction: (params) => {
    return config.axiosHandle().get('v0/logout', params);
  },
  // upload: (body) => {
  //   return config.axiosHandle().post('v0/users/file/upload/videos', body);
  // },
  videoUpload: (body, conf) => {
    return config.axiosHandle().post('v0/user/file/upload/videos', body, conf);
  },
  videoSuggestion: (params) => {
    return config.axiosHandle().get('v0/user/video/suggestion/list', params);
  },
  uploadForm: (body) => {
    return config.axiosHandle().post('v0/users/videos/insert', body);
  },
  updateCategory: (body) => {
    return config.axiosHandle().post('v0/user/update-category', body);
  },
  reportVideo: (id) => {
    return config.axiosHandle().get(`v0/user/video/report/insert/${id}`);
  },
  categoryList: (params) => {
    return config.axiosHandle().get('v0/category/list', params);
  },
  favoriteCategoryList: (params) => {
    return config.axiosHandle().get('v0/favorite/category/list', params);
  },
  ageClassList: (params) => {
    return config.axiosHandle().get('v0/age-class/list', params);
  },
  statusList: (params) => {
    return config.axiosHandle().get('v0/status/list', params);
  },
  videoList: (params) => {
    return config.axiosHandle().get('v0/videos/list', params);
  },
  videoSearchList: (params) => {
    return config.axiosHandle().get('v0/search-all/list', params);
  },
  shortVideoList: (params) => {
    return config.axiosHandle().get('v0/video-short/list', params);
  },
  videoListWatch: (params) => {
    return config.axiosHandle().get('v0/videos-watch/list', params);
  },
  onlineUsersVideo: (videoToken) => {
    return config.axiosHandle().get(`v0/videos-activity/list/${videoToken}`);
  },
  coverImageList: (params) => {
    return config.axiosHandle().get('v0/user/file/list', params);
  },

  videoListToken: (uuid) => {
    return config.axiosHandle().get(`v0/videos/list?video_token=${uuid}`);
  },
  userVideoList: (params) => {
    return config.axiosHandle().get('v0/users/videos/show-all', params);
  },
  keywordsList: () => {
    return config.axiosHandle().get('v0/users/keyword/show');
  },
  videoCommentList: (videoId, params) => {
    return config.axiosHandle().get(`v0/comment/videos/${videoId}`, params);
  },
  videoPageAds: (params) => {
    return config.axiosHandle().get('v0/ads/list', params);
  },
  videoActivity: (videoId, body) => {
    return config.axiosHandle().post(`v0/videos-activity/${videoId}`, body);
  },
  videoLikeDislike: (videoId) => {
    return config
      .axiosHandle()
      .get(`v0/user/like-dislike/${videoId}?type=video`);
  },
  commentLikeDislike: (commentId, params) => {
    return config
      .axiosHandle()
      .get(`v0/user/like-dislike/comment/${commentId}`, params);
  },
  videoAddRemoveInterest: (videoId) => {
    return config
      .axiosHandle()
      .get(`v0/user/add-remove-interest/${videoId}?type=video`);
  },
  videoBookMark: (videoId) => {
    return config
      .axiosHandle()
      .get(`v0/user/bookmark/${videoId}?type=video&search=true`);
  },
  videoFollow: (channelId, body) => {
    return config
      .axiosHandle()
      .post(`v0/user/channel/member/insert/${channelId}`, body);
  },
  channelFollow: (params) => {
    return config.axiosHandle().get(`v0/user/channel/member/list`, params);
  },
  videoAddView: (videoId, params) => {
    return config.axiosHandle().get(`v0/add-view/${videoId}`, params);
  },
  adsAddView: (id, params) => {
    return config.axiosHandle().get(`v0/ads/add-view/${id}`, params);
  },
  share: (videoId, params) => {
    return config.axiosHandle().get(`v0/shared/${videoId}`, params);
  },
  download: (videoId, params) => {
    return config.axiosHandle().get(`v0/download/${videoId}`, params);
  },
  playListApi: (params) => {
    return config.axiosHandle().get('v0/playlist/list', params);
  },
  channelList: (params) => {
    return config.axiosHandle().get('v0/channel/list', params);
  },
  userList: (params) => {
    return config.axiosHandleSocket().get('v0/user/list', params);
  },
  channelListWatch: (params) => {
    return config.axiosHandle().get('v0/channel-watch/list', params);
  },
  channelListDetails: (sl, params) => {
    return config
      .axiosHandle()
      .get(`v0/channel/list/details?token=${sl}&orderBy=createdAt`, params);
  },
  popularUserList: (params) => {
    return config.axiosHandle().get('v0/user/popular/list', params);
  },
  userLogin: (body) => {
    return config.axiosHandle().post(`v0/login`, body);
  },
  userSendCode: (body) => {
    return config.axiosHandle().post(`v0/send-code`, body);
  },
  userSignUp: (body) => {
    return config.axiosHandle().post(`v0/signup`, body);
  },
  changePassword: (body) => {
    return config.axiosHandle().post(`v0/user/change-password`, body);
  },
  userSendForgetCode: (body) => {
    return config.axiosHandle().post(`v0/send-forget-code`, body);
  },
  userForgetPassword: (body) => {
    return config.axiosHandle().post(`v0/forget-password`, body);
  },
  userFavChannelList: (params) => {
    return config.axiosHandle().get(`v0/user/channel/member/list`, params);
  },
  userPlaylistMemberList: (params) => {
    return config.axiosHandle().get('v0/user/playlist/member/list', params);
  },
  userShowProfile: () => {
    return config.axiosHandle().get('v0/user/show-profile');
  },
  channelVideoMember: (channelId) => {
    return config.axiosHandle().get(`v0/channel/video/number/${channelId}`);
  },
  userVideoListInterest: (params) => {
    return config.axiosHandle().get('v0/user/list/interest', params);
  },
  userVideoListBookmarked: (params) => {
    return config.axiosHandle().get('v0/user/list/bookmark', params);
  },
  userVideo: (params) => {
    return config.axiosHandle().get('v0/user/videos/list', params);
  },
  userVideoListLiked: (params) => {
    return config.axiosHandle().get('v0/user/list/like', params);
  },
  userPlaylistMemberInsert: (playlistId) => {
    return config
      .axiosHandle()
      .post(`v0/user/playlist/member/insert/${playlistId}`);
  },
  homeList: (params) => {
    return config.axiosHandle().get('v0/videos/main/page/list', params);
  },
  sendComment: (params) => {
    return config.axiosHandle().post(`v0/user/comment/insert`, params);
  },
  categoryPart: (params) => {
    return config.axiosHandle().get('v0/category/part/list', params);
  },
  uploadUserImage: (body, query = '') => {
    return config
      .axiosHandle()
      .post('v0/user/file/upload/images' + query, body);
  },
  uploadSrt: (body) => {
    return config.axiosHandle().post('v0/user/file/upload/srt', body);
  },
  userUpdateProfile: (body) => {
    return config.axiosHandle().post('v0/user/update-profile', body);
  },
  userProfileVideoList: (params) => {
    return config.axiosHandle().get('v0/user/videos/list', params);
  },
  userProfilePlaylistList: (params) => {
    return config.axiosHandle().get('v0/user/playlist/list', params);
  },
  userProfileChannelList: (params) => {
    return config.axiosHandle().get('v0/user/channel/list', params);
  },
  userSwitchChannelList: (params) => {
    return config.axiosHandle().get('v0/user/channel/switch/list', params);
  },
  userVideoLikeList: (params) => {
    return config.axiosHandle().get('v0/user/list/like', params);
  },
  userVideoInterestList: (params) => {
    return config.axiosHandle().get('v0/user/list/interest', params);
  },
  userVideoBookmarkList: (params) => {
    return config.axiosHandle().get('v0/user/list/bookmark', params);
  },

  feedBack: (params) => {
    return config.axiosHandle().post('v0/feedback/insert', params);
  },
  contactUs: (params) => {
    return config.axiosHandle().post('v0/contact-us/insert', params);
  },
  userChannelListDetails: (sl, params) => {
    return config
      .axiosHandle()
      .get(
        `v0/user/channel/list/details?token=${sl}&orderBy=createdAt`,
        params
      );
  },
  userChannelListDetailsBySort: (params) => {
    return config.axiosHandle().get(`v0/channel/list/details`, params);
  },
  userChannelInsert: (body, id = null) => {
    if (id) {
      return config.axiosHandle().post(`v0/user/channel/update/${id}`, body);
    } else {
      return config.axiosHandle().post('v0/user/channel/insert', body);
    }
  },
  userChannelEdit: (id, params) => {
    return config.axiosHandle().post(`v0/user/channel/update/${id}`, params);
  },
  userPlaylistInsert: (body) => {
    return config.axiosHandle().post('v0/user/playlist/insert', body);
  },
  userPlaylistEdit: (params, id = null) => {
    if (id) {
      return config.axiosHandle().post(`v0/user/playlist/update/${id}`, params);
    } else {
      return config.axiosHandle().post('v0/user/playlist/insert', params);
    }
  },
  userPlaylistVideoDelete: (id, params) => {
    return config
      .axiosHandle()
      .delete(`v0/user/playlist-videos/remove/${id}`, params);
  },
  userPlaylistVideoInsert: (id, params) => {
    return config
      .axiosHandle()
      .post(`v0/user/playlist-videos/insert/${id}`, params);
  },
  perCategoryChannel: (params) => {
    return config.axiosHandle().get('v0/channel/per-category/list', params);
  },
  userVideoDelete: (id, params) => {
    return config.axiosHandle().delete(`v0/user/videos/remove/${id}`, params);
  },
  userPlaylistDelete: (id, params) => {
    return config.axiosHandle().delete(`v0/user/playlist/remove/${id}`, params);
  },
  userChannelDelete: (id, params) => {
    return config.axiosHandle().delete(`v0/user/channel/remove/${id}`, params);
  },
  termsAndConditions: (params) => {
    return config.axiosHandle().get('v0/terms-condition/list/all', params);
  },
  userVideosInsert: (body, id = null) => {
    if (id) {
      return config.axiosHandle().post(`v0/user/videos/update/${id}`, body);
    } else {
      return config.axiosHandle().post(`v0/user/videos/insert`, body);
    }
  },

  tagList: (params) => {
    return config.axiosHandle().get('v0/category/tag/list', params);
  },
  privateUsers: (body) => {
    return config.axiosHandle().post('v0/user/search/channel-username', body);
  },
  sendThumbnail: (body) => {
    return config.axiosHandle().post('v0/user/file/get-image-id', body);
  },
  checkLogin: (params) => {
    return config.axiosHandleSocket().get('v0/user/check-login', params);
  },
  userCommentInsert: (body) => {
    return config.axiosHandle().post('v0/user/comment/insert', body);
  },
  userCommentList: (params) => {
    return config.axiosHandle().get('v0/user/comment/list', params);
  },
  // allUsersList: (params) => {
  //   return config.axiosHandle().get('v0/user/all/list', params);
  // },
  channelUsername: (body) => {
    return config.axiosHandle().post('v0/user/search/channel-username', body);
  },
  videoType: (body) => {
    return config.axiosHandle().get('v0/extension/list', body);
  },
  suggestList: (body) => {
    return config.axiosHandle().get('v0/user/search-word/list', body);
  },
  suggestInsert: (body) => {
    return config.axiosHandle().post('v0/user/search-word/insert', body);
  },
  suggestDelete: (id, params) => {
    return config
      .axiosHandle()
      .delete(`v0/user/search-word/remove/${id}`, params);
  },
  editVideo: (id, body) => {
    return config.axiosHandle().post(`v0/user/videos/update/${id}`, body);
  },

  staticPage: (params) => {
    return config.axiosHandle().get(`v0/staticpage/list`, params);
  },
  layoutUserApis: (params) => {
    return config.axiosHandle().get(`v0/user/get/sign-api/info`, params);
  },

  matchQuizInsert: (body) => {
    return config.axiosHandle().post(`v0/user/match/quiz/insert`, body);
  },
  // /api/v0/user/video/get-just/like-bookmark/{token}
  userVideoActions: (token, params) => {
    return config
      .axiosHandle()
      .get(`v0/user/video/get-just/like-bookmark/${token}`, params);
  },
  CropVideoCustom: (body) => {
    return config.axiosHandle().post(`v0/user/file/upload/videos/custom`, body);
  },
  channelPayment: (id, body) => {
    return config.axiosHandle().post(`v0/user/pay/channel/${id}`, body);
  },
  notificationList: (params) => {
    return config.axiosHandle().get(`v0/user/notification/list`, params);
  },
  removeNotification: (id) => {
    return config.axiosHandle().delete(`v0/user/notification/remove/${id}`);
  },
  removeAllNotification: () => {
    return config.axiosHandle().delete(`v0/user/notification/all-remove`);
  },
  characterGetToken: (UUID) => {
    return config.axiosHandle().get(`v0/user/get/character/token?uuid=${UUID}`);
  },
  getOnlinechatUsers: (UUID) => {
    return config.axiosHandle().get(`v0/chat/room/get-online/${UUID}`);
  },
  requestList: (params) => {
    return config.axiosHandle().get(`v0/request/all-list`, params);
  },
  requestInsert: (body) => {
    return config.axiosHandle().post(`v0/user/request/insert`, body);
  },
  requestLikeDislike: (videoId) => {
    return config
      .axiosHandle()
      .get(`v0/user/like-dislike/${videoId}?type=request`);
  },
  privateChatUsers: (params) => {
    return config.axiosHandle().get(`v0/chat/private/user/list`, params);
  },
  privateChatUsersChat: (params) => {
    return config.axiosHandleSocket().get(`v0/private/get/list`, params);
  },
  // userMessageList: (id, params) => {
  //   return config
  //     .axiosHandleSocket()
  //     .get(`v0/private/get/chat/list/${id}`, params);
  // },
  // videoMessageList: (uuid, params) => {
  //   return config.axiosHandleSocket().get(`v0/room/get/chat/${uuid}`, params);
  // },

  userMessageList: (id, params) => {
    return config
      .axiosHandleSocket()
      .get(`v0/private/get/chat/list/${id}`, params);
  },
  videoMessageList: (uuid, params) => {
    return config.axiosHandleSocket().get(`v0/room/get/chat/${uuid}`, params);
  },
  mediaList: (params) => {
    return config
      .axiosHandleSocket()
      .get(`v0/private/get/file/media/list`, params);
  },
  pinUser: (channelId) => {
    return config.axiosHandleSocket().get(`v0/private/user/pin/${channelId}`);
  },
  muteUser: (channelId) => {
    return config.axiosHandleSocket().get(`v0/private/user/mute/${channelId}`);
  },
  clearHistory: (channelId) => {
    return config
      .axiosHandleSocket()
      .delete(`v0/user/group/remove-history/${channelId}`);
  },
  blockUser: (channelId) => {
    return config.axiosHandleSocket().get(`v0/private/user/block/${channelId}`);
  },
  deleteUser: (roomId) => {
    return config
      .axiosHandleSocket()
      .delete(`v0/private/user/remove/${roomId}`);
  },
  fileTypes: (params) => {
    return config.axiosHandleSocket().get(`v0/file/valid/list`, params);
  },
  onlineStatus: (params) => {
    return config
      .axiosHandleSocket()
      .get(`v0/private/user/change/online-status`, params);
  },
  userInfo: (params) => {
    return config.axiosHandleSocket().get(`v0/user/show-profile`, params);
  },
  userUpdateProfile: (body) => {
    return config.axiosHandleSocket().post('v0/user/update-profile', body);
  },
  createGroup: (body) => {
    return config.axiosHandleSocket().post(`v0/user/group/insert`, body);
  },
  uploadGroupImage: (body) => {
    return config.axiosHandleSocket().post('v0/file/upload/images', body);
  },
  sendFileApi: (body, uuid) => {
    return config
      .axiosHandleSocket()
      .post(`v0/user/file/upload/chat?roomuuid=${uuid}`, body);
  },
  editGroupInfo: (id, body) => {
    return config.axiosHandleSocket().post(`v0/user/group/update/${id}`, body);
  },
  leaveGroup: (roomId) => {
    return config.axiosHandleSocket().delete(`v0/user/group/left/${roomId}`);
  },
  deleteMemberUser: (channelId, params) => {
    return config
      .axiosHandleSocket()
      .get(`v0/user/group/user-delete/${channelId}`, params);
  },
  adminMemberUser: (channelId, params) => {
    return config
      .axiosHandleSocket()
      .get(`v0/user/group/user-permission/${channelId}`, params);
  },
  deleteAccount: (roomId) => {
    return config.axiosHandleSocket().delete(`v0/user/delete-account`);
  },
  favMessage: (chatId, body) => {
    return config
      .axiosHandleSocket()
      .post(`v0/user/chat/favorite/${chatId}`, body);
  },
  favList: (id, params) => {
    return config
      .axiosHandleSocket()
      .get(`v0/user/chat/list/favorite/${id}`, params);
  },
  logOutChat: () => {
    return config.axiosHandleSocket().get(`v0/user/logout`);
  },
};
export default Api;
